// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__3ePlI","rootSmall":"AddTileButton_rootSmall__2yaDN"};